
import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component
export default class Icon extends Vue {
  @Prop({ type: String }) readonly name!: string;
  @Prop({ type: Object, default: () => {} }) readonly customStyles!: Object;
}
